<template>
    <DeactivationConfirmationModal :entities="entities" :saving="saving" @input="onAction" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { EntityPatch, PatchOperationType } from '@evidentid/rpweb-api-client';
    import { Entity } from '@evidentid/tprm-portal-lib/models/dashboard';

    import LoadingModal from '@/components/loading-modal/LoadingModal.vue';
    import DeactivationConfirmationModal
        from '@/modules/entity-management/components/DeactivationConfirmationModal/DeactivationConfirmationModal.vue';
    import { useEntityManagementStore } from '@/modules/entity-management/store';

    // PRODUCT-26110 QA fixes4: declares every event this procedure component `$emit`s --
    // without a declared `emits`, Vue 3 warns "Component emitted event 'abort'/'finish'
    // but it is neither declared in the emits option nor as an 'onAbort'/'onFinish' prop"
    // every time it fires.
    @Component({
        components: { LoadingModal, DeactivationConfirmationModal },
        emits: [ 'abort', 'finish' ],
    })

    export default class DeactivateEntityProcedure extends Vue {
        // PRODUCT-26110 QA fixes4: `uuid` is unused; declared purely so Vue 3 doesn't warn
        // "Extraneous non-props attributes (uuid)" (see UploadEntityDocumentProcedure.vue).
        @Prop({ type: String, default: '' })
        private uuid?: string;

        @Prop({ type: String, default: '' })
        private rpName!: string;

        @Prop({ type: Array, default: () => [] })
        private entities!: Entity[];

        @Prop({ type: Boolean, default: false })
        private isBulk!: boolean;

        private opened: boolean = true;
        private saving: boolean = false;

        private onAction(yes: boolean) {
            yes ? this.deactivateInsured() : this.close();
        }

        private close(): void {
            this.opened = false;
            this.$emit('abort');
        }

        private async deactivateInsured() {
            const { rpName, entities, isBulk } = this;
            this.saving = true;
            await useEntityManagementStore().patchEntities({
                rpName,
                isBulk,
                patch: entities.map((entity) => ({
                    id: entity.id,
                    active: {
                        op: PatchOperationType.replace,
                        newValue: false,
                    },
                } as EntityPatch)),
            });
            this.$emit('finish', this.entities);
        }
    }
</script>
